import * as constants from '../util/constants';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const sectionContactUsForm = $('.section-contact-us form');
    if (sectionContactUsForm.length) {
      const submitBtn = sectionContactUsForm.find('.wpcf7-submit');

      $(document).on('wpcf7submit', function() {
        submitBtn.removeClass('disabled');
      });

      submitBtn.click(function() {
        submitBtn.addClass('disabled');
      });
    }

    const sectionContactForm = $('.section-contact-us .contact-form');
    if (sectionContactForm.length) {
      const datePickerWrapper = sectionContactForm.find('.booking-enquiry-contact-form-card .date-picker-wrapper');
      const recipientSelect = sectionContactForm.find('.booking-enquiry-contact-form-card select[name="dynamicRecipient"]');
      const noticeWrapper = sectionContactForm.find('.booking-enquiry-contact-form-card .notice-wrapper');

      datePickerWrapper.each(function() {
        const _this = $(this);
        const input = _this.find('input');

        _this.on('apply.daterangepicker', function(ev, picker) {
          const formattedDate = picker.startDate.format(constants.OUTAGE_DATE_FORMAT_ISO);

          input.val(formattedDate);
        });
      });

      if (recipientSelect.length) {
        recipientSelect.on('select2:select', function() {
          const _this = $(this);
          const selectedValue = _this.val();
          const value = selectedValue.split('|');
          const tel = value[2];
          const email = value[3];
          noticeWrapper.html('');

          if (tel !== '' || email !== '') {
            const noticeContent = `
              <div class="notice-content">
                <div>Please contact us via the form below or by contacting us directly:</div>
                <div class="details-wrapper">
                  ${tel && (`<a href="tel:${tel}" class="tel">Telephone:&nbsp;<div>${tel}</div></a>`)}
                  ${email && (`<a href="mailto:${email}" class="email">Email:&nbsp;<div>${email}</div></a>`)}
                </div>
              </div>
            `;
            noticeWrapper.html(noticeContent);
          }
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalContactUs.js